import type { OnboardingSection } from './types';

type OnboardingGuideSlide = {
  domain: string;
  order: number;
  component: OnboardingSection | OnboardingSection[];
};
class OnboardingGuideRegister {
  private static instance: OnboardingGuideRegister;

  private registry: OnboardingGuideSlide[] = [];

  private constructor() {}

  public register(type: OnboardingGuideSlide): void {
    this.registry.push(type);
  }

  public get(domain: string): OnboardingSection | OnboardingSection[] | null {
    return this.registry.find(item => item.domain === domain)?.component || null;
  }

  public getAll(): OnboardingGuideSlide[] {
    return this.registry;
  }

  public static getInstance(): OnboardingGuideRegister {
    if (!OnboardingGuideRegister.instance) {
      OnboardingGuideRegister.instance = new OnboardingGuideRegister();
    }
    return OnboardingGuideRegister.instance;
  }

  public static reset() {
    OnboardingGuideRegister.instance = undefined;
  }
}

export { OnboardingGuideRegister };
